import { render, staticRenderFns } from "./ChildControlIssueForm.vue?vue&type=template&id=450f44fa&scoped=true&"
import script from "./ChildControlIssueForm.vue?vue&type=script&lang=js&"
export * from "./ChildControlIssueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f44fa",
  null
  
)

export default component.exports